import React, { useState } from 'react';
import { SOCKET_URL } from '../../services/api';

export default function WidgetEmbed({ gameId }) {
    const [copied, setCopied] = useState(false);
    const [open, setOpen] = useState(false);

    const apiBase = SOCKET_URL; // e.g. https://apimon.mf-league.com
    const uid = `mft-${gameId}`;

    const code = `<div id="${uid}"></div>
<script src="${apiBase}/extern/mf-ticker.js"><\/script>
<script>
  new MFTickerWidget({
    containerId: '${uid}',
    apiBaseUrl: '${apiBase}',
    gameId: '${gameId}'
  });
<\/script>`;

    const handleCopy = () => {
        navigator.clipboard.writeText(code).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <div className="border rounded-xl overflow-hidden bg-white shadow-sm">
            <button
                className="w-full flex items-center justify-between px-4 py-3 text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors"
                onClick={() => setOpen(o => !o)}
            >
                <span>🌐 Widget-Einbettung</span>
                <span className="text-slate-400 text-xs">{open ? '▲ einklappen' : '▼ Code anzeigen'}</span>
            </button>

            {open && (
                <div className="border-t px-4 pb-4">
                    <p className="text-xs text-slate-500 mt-3 mb-2">
                        Diesen Code auf der Vereinswebsite einfügen — der Ticker aktualisiert sich in Echtzeit:
                    </p>
                    <div className="relative">
                        <pre className="bg-slate-900 text-green-400 text-xs rounded-lg p-4 overflow-x-auto leading-relaxed">
                            {code}
                        </pre>
                        <button
                            onClick={handleCopy}
                            className="absolute top-2 right-2 btn btn-xs btn-ghost text-slate-300 hover:text-white"
                        >
                            {copied ? '✓ Kopiert!' : '📋 Kopieren'}
                        </button>
                    </div>
                    <p className="text-xs text-slate-400 mt-2">
                        Direktlink zum Ticker: <a href={`${apiBase}/extern/mf-ticker.js`} target="_blank" rel="noopener noreferrer" className="underline">{apiBase}/extern/mf-ticker.js</a>
                    </p>
                </div>
            )}
        </div>
    );
}
